<clr-header>
  <h4 class="title" style="color: white">CLEAR Safety</h4>
  <div class="header-nav" [clr-nav-level]="1">
    <div class="branding">
      <img src="assets/images/NYS_DepartmentofTransportation_Horizontal_WHITE.png" />
    </div>
  </div>
  <div class="header-actions">
    <div class="header-nav" [class.logged-out]="loggedOut">
      <a
        class="nav-link nav-text"
        href="javascript:void(0);"
        (click)="aboutModal.open()"
        >About</a
      >
      <a
        class="nav-link nav-text"
        aria-label="help"
        [href]="helpUrl"
        target="_blank"
        >Help</a
      >
      <a
        class="nav-link nav-text"
        aria-label="faq"
        [href]="faqUrl"
        target="_blank"
        >FAQ</a
      >
    </div>
    <clr-dropdown *ngIf="!loggedOut">
      <button
        class="nav-text"
        clrDropdownTrigger
        aria-label="open user profile"
      >
        <clr-icon shape="user"></clr-icon>
        {{ username }}
        <clr-icon shape="caret down"></clr-icon>
      </button>
      <clr-dropdown-menu *clrIfOpen="dropdownOpen" clrPosition="bottom-right">
        <b class="account-type" *ngIf="accountType">{{
          accountType | titlecase
        }}</b>
        <a clrDropdownItem (click)="getTables()">Preferences</a>
        <a name="logout" (click)="logout()" clrDropdownItem>Log out</a>
      </clr-dropdown-menu>
    </clr-dropdown>
  </div>
</clr-header>
<div *ngIf="loading" class="loading-bar progress loop">
  <progress></progress>
</div>
<div [@enterAnimation] *ngIf="alert" class="nav-alert">
  <clr-alert [clrAlertType]="alert?.type" [clrAlertAppLevel]="true">
    <clr-alert-item>
      <span class="text-center alert-text">
        {{ alert?.message }}
      </span>
    </clr-alert-item>
  </clr-alert>
</div>

<clr-modal #aboutModal id="app-info-modal" [clrModalSize]="'md'">
  <h3 class="text-white modal-title">Application Info</h3>
  <div class="modal-body">
    <div class="clr-row">
      <div class="clr-col">
        <h4 style="margin-top: 0px; font-weight: 500; color: black">
          CLEAR Safety
        </h4>
        <hr />
      </div>
    </div>
    <div class="clr-row">
      <div class="clr-col-6">
        <span>Version:</span>
      </div>
      <div class="clr-col-6">
        <span>{{ version }}</span>
      </div>
    </div>
    <div class="clr-row">
      <div class="clr-col-6">
        <span>Version Date:</span>
      </div>
      <div class="clr-col-6">
        <span>{{ versionDate }}</span>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline" (click)="aboutModal.close()">
      Close
    </button>
  </div>
</clr-modal>
